import { requestApi } from '../Api';

export const getHipaa = async (navigate, params) => {
  return requestApi({ navigate, params, url: '/api/patient/checkin/get_hipaa_form' });
};
